import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface UseHomePageTabsReturn {
  activeTab: number;
  setActiveTab: (index: number) => void;
  handleHeadClick: (label: string, index: number) => void;
  handleChatClick: (index: number) => void;
}

/**
 * 管理 HomePage 的 Tab 切换逻辑
 */
export function useHomePageTabs(
  headerRef: React.RefObject<{ setActiveTab: (index: number) => void }>
): UseHomePageTabsReturn {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<number>(location.state?.scjdonclusion ? 1 : 0);

  // 清理 location.state
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);

  const handleHeadClick = (_: string, index: number) => {
    console.log('handleHeadClick', index);
    setActiveTab(index);
  };

  const handleChatClick = (index: number) => {
    console.log('handleChatClick', headerRef.current, index);
    setActiveTab(index);
    // 同步更新 Header 组件的 Tab 状态
    if (headerRef.current) {
      headerRef.current.setActiveTab(index);
    }
  };

  return {
    activeTab,
    setActiveTab,
    handleHeadClick,
    handleChatClick
  };
}
